module.exports = __webpack_public_path__ + "static/media/preview_icn_dark.da824996.png";